export enum CompletenessOptions {
    goed = 'Goed',
    onvoldoende = 'Onvoldoende',
    voldoende = 'Voldoende',
}
